import { IConfigResponse } from "../models/config/IConfig";
import HttpProvider from "../providers/HttpProvider";

export default class AppConfigApi {
    public static async GetConfig(): Promise<IConfigResponse> {
        const uriStr = `${this.apiUrl}/get-config`;

        const response = await HttpProvider.GetRequest(uriStr);
        if (!response.ok) {
            return {} as IConfigResponse;
        }

        return await response.json();
    }

    private static readonly apiUrl = "/api/config";
}
